import { Api } from './Api'

class PowerOfAttorney {
  get (
    siteId,
    typeId
  ) {
    return fetch(Api.getBaseUrl() + 'powerofattorney/' + siteId + '?type_id=' + typeId, Api.getOptions())
  }
}

export default PowerOfAttorney
